<template>
  <div class="accountingList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
        :disabled="loading ? true : false"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <template v-if="menuState == 3">
              <div class="list-item">
                {{ $t.salesManagement.mainWbNumber }}：{{ item.PWB_Number }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.sideWbNumber }}：{{ item.WB_Number }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.warehouseWorkNumber }}：{{
                  item.WarehouseWorkNumber
                }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.deliveryPort }}：{{ item.POL }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.destinationPort }}：{{ item.POD }}
              </div>
              <div class="list-item">{{ $t.salesManagement.atd }}：{{ item.ATD }}</div>
            </template>
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.salesManagement.creditDate }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.nuclearAccountNo }}：{{ item.NuclearAccountNo }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.shortName }}：{{ item.CompanyNameSn }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.nuclearType }}：{{ item.NuclearTypeStr }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.bank }}：{{ item.AccountNickName }}
              </div>
            </template>
            <template v-if="menuState == 1">
              <div class="list-item">
                {{ $t.salesManagement.mainWbNumber }}：{{ item.PWB_Number }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.sideWbNumber }}：{{ item.WB_Number }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.warehouseWorkNumber }}：{{
                  item.WarehouseWorkNumber
                }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.shortName }}：{{ item.CompanyNameSn }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.invoiceNo }}：{{ item.InvoiceNo }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.createDate }}：{{ item.InvoiceDate }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.deliveryPort }}：{{ item.POL }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.destinationPort }}：{{ item.POD }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.billTotal }} ({{ settlementCurrency }})：{{
                  item.InvoiceAmount
                }}
              </div>
            </template>
            <div class="buttons">
              <van-button
                class="primary-btn"
                size="small"
                type="primary"
                @click="gotoDetail(item)"
                >{{ $t.meta.editButton }}</van-button
              >
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div v-if="menuState == 2">
          <div class="radio-label">{{ $t.salesManagement.nuclearType }}</div>
          <van-radio-group v-model="nuclearType" direction="horizontal">
            <van-radio :name="1">{{ $t.salesManagement.nuType1 }}</van-radio>
            <van-radio :name="2">{{ $t.salesManagement.nuType2 }}</van-radio>
            <van-radio :name="3">{{ $t.salesManagement.nuType3 }}</van-radio>
          </van-radio-group>
        </div>

        <div class="radio-label">{{ $t.meta.customerTitle }}</div>
        <van-radio-group v-model="customerType" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.enterprise }}</van-radio>
          <van-radio :name="2">{{ $t.meta.personal }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>

          <van-popup v-model="showStartPicker" position="bottom">
            <van-datetime-picker
              type="date"
              :title="$t.meta.beginDate"
              :formatter="formatter"
              :confirm-button-text="$t.meta.confirm"
              :cancel-button-text="$t.meta.cancel"
              @confirm="dateChange($event, 'start')"
              @cancel="showStartPicker = false"
              :min-date="currentDate"
              v-model="selectDate"
            />
          </van-popup>

          <van-popup v-model="showEndPicker" position="bottom">
            <van-datetime-picker
              type="date"
              :title="$t.meta.endDate"
              :formatter="formatter"
              :confirm-button-text="$t.meta.confirm"
              :cancel-button-text="$t.meta.cancel"
              @confirm="dateChange($event, 'end')"
              @cancel="showEndPicker = false"
              :min-date="currentDate"
              v-model="selectDate"
            />
          </van-popup>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "accountingList",
  data() {
    return {
      settlementCurrency: "",
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.salesManagement.accoutingTab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.salesManagement.accoutingTab2,
          name: 2,
          count: 0,
        },
        {
          title: this.$t.salesManagement.accoutingTab3,
          name: 3,
          count: 0,
        },
      ],
      tableData: [],
      rateList: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.salesManagement.recommend,
          value: 1,
        },
        {
          text: this.$t.salesManagement.wbNumber,
          value: 2,
        },
        {
          text: this.$t.salesManagement.customerId,
          value: 3,
        },
        {
          text: this.$t.salesManagement.companyName,
          value: 4,
        },
      ],
      nuclearType: null,
      customerType: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList();
    },
  },
  created() {
    this.defaultDate();
  },
  methods: {
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10 ? "0" + date.getDate().toString() : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    gotoDetail(item) {
      var data = item;
      data.menuState = this.menuState;
      data.SettlementCurrency = this.settlementCurrency;
      data.RateList = this.rateList;
      localStorage.setItem("accountingDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "accountingDetail",
        name: "accountingDetail",
        query: [],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    isFilter() {
      if (this.menuState == 2) {
        if (this.nuclearType || this.customerType) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.customerType) {
          return true;
        } else {
          return false;
        }
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.nuclearType = null;
      this.customerType = null;
      this.showFilter = false;
      this.defaultDate();
      this.initList();
      this.getList();
    },
    filterSubmit() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (this.menuState == 1 || this.menuState == 3) {
        this.searchTypeOptions = [
          {
            text: this.$t.salesManagement.recommend,
            value: 1,
          },
          {
            text: this.$t.salesManagement.mainWbNumber,
            value: 2,
          },
          {
            text: this.$t.salesManagement.sideWbNumber,
            value: 3,
          },
          {
            text: this.$t.salesManagement.customerId,
            value: 4,
          },
          {
            text: this.$t.salesManagement.companyName,
            value: 5,
          },
        ];
      }
      if (this.menuState == 2) {
        this.searchTypeOptions = [
          {
            text: this.$t.salesManagement.customerId,
            value: 1,
          },
          {
            text: this.$t.salesManagement.nuclearAccountNo,
            value: 2,
          },
          {
            text: this.$t.salesManagement.companyName,
            value: 3,
          },
        ];
      }
    },
    getList() {
      var param = {
        CustomerType: this.customerType,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      if (this.menuState == 1 || this.menuState == 3) {
        param.Referrer = this.searchType == 1 ? this.searchText : "";
        param.WB_Number = this.searchType == 2 ? this.searchText : "";
        param.CustomerNumber = this.searchType == 3 ? this.searchText : "";
        param.CompanyName = this.searchType == 4 ? this.searchText : "";
      }
      if (this.menuState == 2) {
        param.CustomerNumber = this.searchType == 1 ? this.searchText : "";
        param.NuclearAccountNo = this.searchType == 2 ? this.searchText : "";
        param.CompanyName = this.searchType == 3 ? this.searchText : "";
      }
      var request = null;
      if (this.menuState == 3) {
        request = this.$api.salesManagement.getProfitStatisticsList(param);
      } else if (this.menuState == 2) {
        param.NuclearType = this.nuclearType;
        request = this.$api.salesManagement.getNuclearAccountRecordsList(param);
      } else {
        request = this.$api.salesManagement.getReceivablePaymentList(param);
      }
      request
        .then((res) => {
          if (this.menuState == 3) {
            this.tableData = res.data.ProfitableList;
            this.rateList = res.data.RateList;
          } else if (this.menuState == 2) {
            this.tableData = res.data;
          } else {
            this.tableData = res.data.ReceivablePayment.DetailList;
            this.rateList = res.data.RateList;
          }
          this.settlementCurrency = res.data.SettlementCurrency;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.accountingList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;

    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;

      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;

        .van-search__content {
          padding: 0px;
          margin-right: 10px;

          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }

        .custom-date {
          padding: 10px;

          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }

          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }

          .van-button {
            vertical-align: middle;
          }
        }
      }

      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;

        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }

  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);

      .list-item {
        margin-bottom: 10px;
      }

      .list-item:last-child {
        margin-bottom: 0px;
      }

      .buttons {
        text-align: right;

        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }

  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }

  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }

  .van-radio-group {
    margin-bottom: 20px;
  }

  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;

    ::v-deep .van-radio__label {
      color: #646566;
    }
  }

  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;

    .van-cell:after {
      border: none;
    }

    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;

      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }

      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }

  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;

    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }

    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
}
</style>
